import { MediaDownloadService } from "../services/media.service"

export const download = async (ID: string) => {
    const r = await MediaDownloadService(ID);
    if(r.success && r.data) {
        const d: string = r.data || ''
        window.open(d)
    }
}